import React, { useEffect, useRef } from 'react'
import TextDecoration from '../utility/TextDecoration';
import VizSensor from 'react-visibility-sensor';
import styles from './martcard.module.css'
import sty from '../listings/cards/card.module.css'
import { useViewport } from '../utility/useViewport';

export const BasicHomeMart = (props) => {
    const listing = props.listing;
    const thumb = listing.thumbnailImage ? listing.thumbnailImage : 'assets/Desert.jpg'

    let isViewCounted = false;
    const timeOut = useRef(null);
    const isMobile = useViewport()
    // const runTimer = (infocus) => {
    //     if (!isViewCounted && infocus)
    //         timeOut.current = setTimeout(() => countView(), 5000);
    //     else if (!infocus && timeOut.current)
    //         clearTimeout(timeOut.current)
    // }
    const handleClick = () => {
        !isViewCounted && countView();
        props.showContent(listing)
    }
    const countView = () => {
        timeOut.current && clearTimeout(timeOut.current)
        isViewCounted = true;
        //listingService.updateSingleListingViews(null, listing);
    }
    useEffect(() => {
        return () => timeOut.current && clearTimeout(timeOut.current)
    }, [timeOut])

    return (
        <VizSensor
        // onChange={(isVisible) => {
        //     runTimer(isVisible)
        // }}
        >
            <div key={listing.hpId} className={`col-12 col-sm-6 col-lg-4 col-xl-3 col-xxl-2 low_padding`}>
                <div className={`${sty.listing_card_video} ${styles.cardHover}`} onClick={handleClick}>
                    {/* <div className="col-4 no_padding"> */}
                    <div className={sty.listing_thumb_image_video}>
                        <img alt={listing.martName} className={`img-fluid`} loading='lazy' src={process.env.REACT_APP_IMAGES_URL + thumb} />
                    </div>
                    {/* </div> */}
                    <div className="listing_details">
                        <h3 className={isMobile ? sty.mob_listing_title_video : sty.listing_title_video}>{TextDecoration.ellipsize(listing.martName, 100)}</h3>
                        <div className="listing_address">
                            <div className={sty.listing_info_box_desc_newsArt_video}>
                                {TextDecoration.ellipsize(listing.businessDescription, 140)}
                            </div>
                            <div className={sty.basicVideoSubCat}>
                                <span className={styles.name_span}>Location:</span> {listing.businessAddress}
                            </div>
                        </div>
                    </div>
                    {(props.viewedContentIds.includes(listing.hpId)) ?
                        <div className="col-md-12">
                            <i className={`fas fa-check-circle ${styles.viewed_mark_home} ${styles.viewed_right_home}`}></i>
                        </div> : null
                    }
                </div>
            </div>
        </VizSensor>
    )
}